import React from 'react';
import LossScreen from './screens/Loss/LossScreen';

function Loss() {
  return (
    <>
      <LossScreen />
    </>
  );
}

export default Loss;
